module.exports = __webpack_public_path__ + "static/media/neighborhood.db956363.png";